import { isHidden } from "@scalar/workspace-store/helpers/is-hidden";
//#region src/v2/blocks/scalar-auth-selector-block/helpers/oauth-flows.ts
/**
* Returns the OAuth2 flow keys to show in the auth UI, in display order.
*
* Flows marked with `x-scalar-ignore` (or `x-internal`) are dropped. The rest are sorted by
* `x-order` ascending, with ordered flows first and unordered flows keeping their document order.
* The first key in the result is the default (pre-selected) flow tab, so giving a flow the lowest
* `x-order` both moves it to the front and makes it the default.
*/
var getVisibleOrderedFlowKeys = (flows) => {
	if (!flows) return [];
	return Object.entries(flows).filter((entry) => entry[1] !== void 0 && !isHidden(entry[1])).map(([key, flow], index) => ({
		key,
		order: flow["x-order"],
		index
	})).sort((a, b) => {
		if (a.order !== void 0 && b.order !== void 0) return a.order - b.order;
		if (a.order !== void 0) return -1;
		if (b.order !== void 0) return 1;
		return a.index - b.index;
	}).map((entry) => entry.key);
};
//#endregion
export { getVisibleOrderedFlowKeys };

//# sourceMappingURL=oauth-flows.js.map